fragment ProspectorContactsFragment on McfxViqContact {
    id
    fullName
    hasPhone
    hasEmail
    hasLinkedinUrl
    location
    jobTitle
    position
    industry
    companySize {
        gte
        lte
    }
    companyName
    companyLocation
    companyIndustry
    companyWebsite
    companyRevenue {
        gte
        lte
    }
    initials
}
